export const mask = {
  maskLogin: {
    regex: "^[0-9a-zA-Z-_][0-9a-zA-Z-_\\s]+$",
    placeholder: "",
  },
};
